<template>
    <div>
        <div><label>{{field.etiqueta}}</label></div>
        <v-btn
            color="primary"
            link :href="field.datos.link_url"
            :target="field.datos.link_target"
        >
            {{ field.datos.link_name }}
            <v-icon small right>fas fa-external-link-alt</v-icon>

        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "Redirect",
        props: ['field', 'readonly', 'label', 'formValues'],
        data(){
            return {

            }
        },

        methods: {

        }
    }
</script>